import React from 'react'
import { Progress } from 'antd'
import { QrCodeState } from 'Types/QrCode.d'

interface ProgressBarProps {
  state: QrCodeState
}

const ProgressBar: React.FC<ProgressBarProps> = ({ state }) => {
  if (!state.showProgress) return null

  return (
    <div className="my-6 p-4 bg-white rounded shadow">
      <Progress percent={state.loadingProgress} status="active" strokeColor="#4f46e5" />
      <p className="text-center text-gray-500 mt-2">
        {state.loadingProgress < 100 
          ? `Processing: ${state.loadingProgress}% complete${state.shorteningUrls ? ' (Shortening URLs...)' : ''}` 
          : 'Finalizing...'
        }
      </p>
    </div>
  )
}

export default ProgressBar 